var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EBEBEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7779_7478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8326 23.8334L20.4992 20.5M20.4992 20.5L17.1659 23.8334M20.4992 20.5V28M27.4909 25.825C28.3037 25.3819 28.9458 24.6808 29.3158 23.8322C29.6858 22.9837 29.7627 22.0361 29.5344 21.1389C29.3061 20.2418 28.7855 19.4463 28.0548 18.8779C27.3241 18.3095 26.425 18.0006 25.4992 18H24.4492C24.197 17.0244 23.7269 16.1186 23.0742 15.3509C22.4215 14.5831 21.6033 13.9732 20.681 13.5672C19.7587 13.1612 18.7564 12.9695 17.7493 13.0066C16.7423 13.0437 15.7568 13.3086 14.8669 13.7814C13.977 14.2542 13.2058 14.9226 12.6114 15.7363C12.017 16.5501 11.6148 17.488 11.4351 18.4795C11.2553 19.4711 11.3027 20.4905 11.5736 21.4611C11.8445 22.4317 12.3319 23.3282 12.9992 24.0834",
    stroke: "#141414",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7779_7478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10.5 10.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUpload);
export default __webpack_public_path__ + "static/media/image-upload.7a5d5865ed27790d86482cc1e4ff63b5.svg";
export { ForwardRef as ReactComponent };